export default "__VITE_ASSET__CPmfOvkJ__"